import { gsap, TimelineMax, Power2, Power4, CSSRulePlugin, ScrollTrigger, MorphSVGPlugin } from 'gsap/all';
import $ from 'jquery';
require("../__vendor/SplitText.min.js");

gsap.registerPlugin(CSSRulePlugin, ScrollTrigger); 

const accordion = () => {
    $(document).on("click", ".accordion-item h2", (e) => {
        e.preventDefault();

        $(e.target).toggleClass("active").parent().find("> div").slideToggle(500);
    });
};

export default accordion;